import {parseCookie} from 'cookie';

export const SUPPORTED_LOCALES=['es','en'];
export const DEFAULT_LOCALE='es';

export function readLocaleCookie(cookieHeader:string|undefined):string|null{
	if(!cookieHeader) return null;
	let value:string|undefined;
	try{
		value=parseCookie(cookieHeader)['locale'];
	}catch{
		return null;
	}
	return value && SUPPORTED_LOCALES.includes(value) ? value : null;
}

export function resolveLocale(cookieHeader:string|undefined,negotiated:string|false|undefined):string{
	return readLocaleCookie(cookieHeader) ?? (negotiated || DEFAULT_LOCALE);
}
